import { createSlice } from "@reduxjs/toolkit";

export const tourSlice = createSlice({
  name: "tour",
  initialState: {
    startTour: false,
    allTours: {},
    selectedTour: [],
    currentStepIndex: 0,
  },

  reducers: {
    setStartTour: (state, action) => {
      state.startTour = action.payload;
    },
    setTour: (state, action) => {
      state.selectedTour = action.payload;
    },
    removeTour: (state, action) => {
      state.selectedTour = [];
      state.currentStepIndex = 0;
    },
    setCurrentStepIndex: (state, action) => {
      state.currentStepIndex = action.payload;
    },
  },
});

export const { setStartTour, setTour, removeTour, setCurrentStepIndex } = tourSlice.actions;

export const getStartTour = (state) => {
  return state.tour.startTour;
};
export const getAllTours = (state) => {
  return state.tour.allTours;
};

export const getSelectedTour = (state) => {
  return state.tour.selectedTour;
};

export const getCurrentStepIndex = (state) => {
  return state.tour.currentStepIndex;
};

export default tourSlice.reducer;
